import { Document } from "../Document/Document.type";
import { ProformaItem } from "../Proforma/Proforma.type";
import { User } from "../User/User.type";
import { ApiCallState } from "../Utils";

export type ProformaComparison = {
  id: number;
  no: number;
  purchase_requisition_id: number;
  date: string;
  document_id:number;
  user_id: number;
  checked_by?: number;
  approved_by?: number;
  authorized_by?: number;

  document:Document;
  user?: User;
  proforma_comparison_checked_by?: User;
  proforma_comparison_approved_by?: User;
  proforma_comparison_authorized_by?: User;
  proforma_comparison_items: ProformaComparisonItem[];
  proforma_comparison_statuses: ProformaComparisonStatus[];
};

export type ProformaComparisonStatus = {
  proforma_comparison_id: number;
  type: "View" | "Check" | "Approve" | "Authorize";
  status: number;
  assigned_by: number;
  user_id: number;
  id: number;
  user?: User;
};

export type ProformaComparisonItem = {
  comparison_type: any;
  remark: string;
  remark2:string;
  expire_date: string;
  proforma_item: ProformaItem;
};

export type ProformaComparisonStateTypes = {
  fetchAll: ApiCallState<ProformaComparison[]>;
  fetchOne: ApiCallState<ProformaComparison | {}>;
};

export const ProformaComparisonActionTypes = {
  FETCH_ALL_PROFORMA_COMPARISON: "FETCH_ALL_PROFORMA_COMPARISON",
  FETCH_ALL_PROFORMA_COMPARISON_RESET: "FETCH_ALL_PROFORMA_COMPARISON_RESET",
  FETCH_ALL_PROFORMA_COMPARISON_FAILURE:
    "FETCH_ALL_PROFORMA_COMPARISON_FAILURE",
  FETCH_ALL_PROFORMA_COMPARISON_SUCCESS:
    "FETCH_ALL_PROFORMA_COMPARISON_SUCCESS",

  FETCH_ONE_PROFORMA_COMPARISON: "FETCH_ONE_PROFORMA_COMPARISON",
  FETCH_ONE_PROFORMA_COMPARISON_RESET: "FETCH_ONE_PROFORMA_COMPARISON_RESET",
  FETCH_ONE_PROFORMA_COMPARISON_FAILURE:
    "FETCH_ONE_PROFORMA_COMPARISON_FAILURE",
  FETCH_ONE_PROFORMA_COMPARISON_SUCCESS:
    "FETCH_ONE_PROFORMA_COMPARISON_SUCCESS",
};
